import React from 'react';
import { IGitTrailResponse } from '../../../utils/GitTrail/gitTrail.interface';
import StatCard from '../../StatCard';

interface Props {
  trailStats: IGitTrailResponse | null;
}

const trailStatsStatsBar = ({ trailStats }: Props) => {
  const total = trailStats?.key ? trailStats.total + '+' : trailStats?.total;
  const pullOperations = trailStats?.key
    ? trailStats.pullOperations + '+'
    : trailStats?.pullOperations;
  const pushOperations = trailStats?.pushOperations
    ? trailStats.pushOperations + '+'
    : trailStats?.pushOperations;
  return (
    <div className="w-full max-w-full bg-offwhite overflow-x-auto py-2 px-4 mt-2 rounded-md scroll-smooth">
      <div className="w-full flex justify-start gap-2">
        {total !== undefined && (
          <StatCard
            className="flex-grow w-[250px] px-4 py-6"
            title="Total Operations"
            value={total}
          />
        )}
        {pullOperations !== undefined && (
          <StatCard
            className="flex-grow w-[250px] px-4 py-6"
            title="Pull Operations"
            value={pullOperations}
          />
        )}
        {pushOperations !== undefined && (
          <StatCard
            className="flex-grow w-[250px] px-4 py-6"
            title="Push Operations"
            value={pushOperations}
          />
        )}
        {(trailStats?.activeOrg ?? trailStats?.activeUser) && (
          <div className="flex flex-grow flex-col bg-white border shadow-lg rounded-md p-4">
            <h4 className="text-xl font-bold">Most Active</h4>
            {trailStats?.activeOrg && (
              <div className="flex mt-2">
                <p className="w-32 font-bold text-md">Organization : </p>
                <p className="text-md">{trailStats.activeOrg}</p>
              </div>
            )}
            {trailStats?.activeUser && (
              <div className="flex mt-1">
                <p className="w-32 font-bold text-md">User : </p>
                <p className="text-md">{trailStats.activeUser}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default trailStatsStatsBar;
